import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, apiError } from "../../lib/api";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Textarea } from "../ui/textarea";

const FIELDS = [
  ["brand_name", "Brand Name"],
  ["tagline", "Tagline"],
  ["secondary_tagline", "Secondary Tagline"],
  ["hero_text", "Homepage Hero Text"],
  ["hero_image", "Hero Image URL"],
  ["about_title", "About Title"],
  ["phone", "Contact Number"],
  ["email", "Contact Email"],
  ["whatsapp", "WhatsApp Number (with country code, digits only)"],
  ["address", "Address"],
  ["hours", "Opening Hours"],
  ["instagram", "Instagram Link"],
  ["facebook", "Facebook Link"],
  ["map_query", "Google Maps Search Query"],
];

export const SettingsManager = () => {
  const [form, setForm] = useState({});
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/settings").then((r) => setForm(r.data));
  }, []);

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const { data } = await api.put("/admin/settings", form);
      setForm(data);
      toast.success("Website details updated");
    } catch (err) {
      toast.error(apiError(err.response?.data?.detail));
    } finally {
      setSaving(false);
    }
  };

  return (
    <form onSubmit={save} data-testid="admin-settings-manager">
      <h2 className="font-serif text-2xl text-cream">Website Details</h2>
      <div className="mt-6 grid gap-5 md:grid-cols-2">
        {FIELDS.map(([key, label]) => (
          <div key={key}>
            <Label className="text-xs uppercase tracking-[0.15em] text-muted-foreground">{label}</Label>
            <Input value={form[key] || ""} data-testid={`settings-${key}-input`}
              onChange={(e) => setForm({ ...form, [key]: e.target.value })} className="mt-1.5" />
          </div>
        ))}
      </div>
      <div className="mt-5">
        <Label className="text-xs uppercase tracking-[0.15em] text-muted-foreground">About Us Text</Label>
        <Textarea value={form.about_text || ""} rows={5} data-testid="settings-about_text-input"
          onChange={(e) => setForm({ ...form, about_text: e.target.value })} className="mt-1.5" />
      </div>
      <Button type="submit" disabled={saving} data-testid="settings-save-btn"
        className="mt-6 rounded-full bg-copper text-charcoal hover:bg-caramel">
        {saving ? "Saving…" : "Save Changes"}
      </Button>
    </form>
  );
};
